module.exports = __webpack_public_path__ + "static/img/db-life-smart-phone-sales-img-02-05@m.7a1a5ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life-smart-phone-sales/optimized/db-life-smart-phone-sales-img-02-05@m.jpg
// module id = Z2hh
// module chunks = 0